import { render, staticRenderFns } from "./DealerPricesForm.vue?vue&type=template&id=2bd9141c&scoped=true"
import script from "./DealerPricesForm.vue?vue&type=script&lang=js"
export * from "./DealerPricesForm.vue?vue&type=script&lang=js"
import style0 from "./DealerPricesForm.vue?vue&type=style&index=0&id=2bd9141c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd9141c",
  null
  
)

export default component.exports